export default __webpack_public_path__ + "static/media/landscape27.c18a76cb.jpeg";